import React, { Fragment } from 'react'
import { AppstoreAddOutlined } from "@ant-design/icons";
import { ButtonActiveModal } from '../../../../components/Buttons/ButtonActiveModal'
import { Input } from 'antd';

function HeaderTag({ handleOpenModalCreate, handleChangeSearch, searchValue }) {
    return (
        <Fragment>
            <ButtonActiveModal
                icon={<AppstoreAddOutlined />}
                action={handleOpenModalCreate}
                className="bg-primaryTwo hover:bg-primaryTwoHover px-6 py-2 flex justify-center items-center lg:ml-auto"
                size={{ w: 144, h: 32 }}
                title="Crear Etiquetas"
            />
            <Input.Search
                placeholder="Búsqueda por Etiquetas"
                onChange={(e) => handleChangeSearch(e.target.value)}
                value={searchValue}
                className="w-full md:max-w-64 order-last sm:mt-2 md:mt-0"
            />
        </Fragment>
    )
}

export default HeaderTag